import baseURL from "../baseUrl";
import { timeZone } from "../constants";
import getAccessToken from "../../accessToken";

import {
  UpdatePasswordParameters,
  UpdateProfileImageParameter,
  UpdateProfileParameters,
  SendNewEmailOtpParams,
  VerifyOldEmailOtpParams,
  VerifyNewEmailOtpParams,
  SendNewPhoneOtpParams,
  VerifyOldPhoneOtpParams,
  VerifyNewPhoneOtpParams,
} from "./types";

class Profile {
  async getProfile() {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/profile`, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.json();
  }
  async updateProfile(data: UpdateProfileParameters | FormData) {
    const accessToken = getAccessToken();
    const isFormData = data instanceof FormData;

    const response = await fetch(`${baseURL}/profile-update`, {
        method: "PUT",
        headers: {
            timezone: timeZone,
            Authorization: `Bearer ${accessToken}`,
            ...(isFormData ? {} : { "Content-Type": "application/json" }), 
        },
        body: isFormData ? data : JSON.stringify(data),
    });

    return response.json();
}

  async changePasswords(data: UpdatePasswordParameters) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/update-password`, {
      method: "post",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }
  async setProfilePicture(data: UpdateProfileImageParameter) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/user/profile/updateImage`, {
      method: "post",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async deleteProfile(data?: { confirmation: string; password: string }) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/delete`, {
      method: "delete",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        confirmation: data?.confirmation || "DELETE",
        password: data?.password || "",
      }),
    });
    return response.json();
  }

  async restoreAccount(data: { email: string; password: string }) {
    const response = await fetch(`${baseURL}/customer/auth/restore-account`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  // Email change flow
  async sendOldEmailOtp() {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/send-old-email-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.json();
  }

  async verifyOldEmailOtp(data: VerifyOldEmailOtpParams) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/verify-old-email-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async sendNewEmailOtp(data: SendNewEmailOtpParams) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/send-new-email-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async verifyNewEmailOtp(data: VerifyNewEmailOtpParams) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/verify-new-email-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  // Phone change flow
  async sendOldPhoneOtp() {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/send-old-phone-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.json();
  }

  async verifyOldPhoneOtp(data: VerifyOldPhoneOtpParams) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/verify-old-phone-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async requestPhoneChangeOtp(data: SendNewPhoneOtpParams) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/request-phone-change-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async verifyPhoneChangeOtp(data: VerifyNewPhoneOtpParams) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/verify-phone-change-otp`, {
      method: "POST",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }
}

const instance = new Profile();

export default instance;
